import { ReactNode } from 'react';
import GroupAirport from '../images/GroupAirportLougeAccess.svg';
import GroupCashless from '../images/GroupCashlessPayments.svg';
import GroupSupport from '../images/Group247PremiumSupport.svg';

export const GROUP_BOOKING_CHECKLIST: string[] = [
    'Booking support for all airline carriers, at lowest possible fares. We will care only for your flights, for now ;)',
    '24x7 customer service and support for all your queries and travel needs',
    'More savings with the best deals and offers',
];

export interface GroupBookingFeature {
    icon: ReactNode;
    label: string;
    text: string;
}

export const GROUP_BOOKING_FEATURES: GroupBookingFeature[] = [
    {
        icon: (
            <svg width={48} x="0px" y="0px" viewBox="0 0 24 24">
                <g transform="translate(0, 0)" fill="none">
                    <rect x="1" y="1" fill="none" stroke="currentColor" vectorEffect="non-scaling-stroke" strokeLinecap="square" strokeMiterlimit="10" width="22" height="22" strokeLinejoin="miter"></rect>
                    <line data-color="color-2" fill="none" stroke="currentColor" vectorEffect="non-scaling-stroke" strokeLinecap="square" strokeMiterlimit="10" x1="16" y1="8" x2="20" y2="8" strokeLinejoin="miter"></line>
                    <line data-color="color-2" fill="none" stroke="currentColor" vectorEffect="non-scaling-stroke" strokeLinecap="square" strokeMiterlimit="10" x1="4" y1="8" x2="6" y2="8" strokeLinejoin="miter"></line>
                    <line data-color="color-2" fill="none" stroke="currentColor" vectorEffect="non-scaling-stroke" strokeLinecap="square" strokeMiterlimit="10" x1="8" y1="16" x2="4" y2="16" strokeLinejoin="miter"></line>
                    <line data-color="color-2" fill="none" stroke="currentColor" vectorEffect="non-scaling-stroke" strokeLinecap="square" strokeMiterlimit="10" x1="20" y1="16" x2="18" y2="16" strokeLinejoin="miter"></line>
                    <circle data-color="color-2" fill="none" stroke="currentColor" vectorEffect="non-scaling-stroke" strokeLinecap="square" strokeMiterlimit="10" cx="9" cy="8" r="3" strokeLinejoin="miter"></circle>
                    <circle data-color="color-2" fill="none" stroke="currentColor" vectorEffect="non-scaling-stroke" strokeLinecap="square" strokeMiterlimit="10" cx="15" cy="16" r="3" strokeLinejoin="miter"></circle>
                </g>
            </svg>
        ),
        label: 'Customised Booking Options',
        text: 'We customise and curate your trip as per your travel preferences. Just let us know!',
    },
    {
        icon: (
            <svg width={48} x="0px" y="0px" viewBox="0 0 24 24">
                <g transform="translate(0, 0)" fill="none">
                    <path fill="none" stroke="currentColor" vectorEffect="non-scaling-stroke" strokeLinecap="square" strokeMiterlimit="10" d="M6,3H3C1.895,3,1,3.895,1,5 v0c0,1.105,0.895,2,2,2" strokeLinejoin="miter"></path>
                    <polyline data-color="color-2" fill="none" stroke="currentColor" vectorEffect="non-scaling-stroke" strokeLinecap="square" strokeMiterlimit="10" points=" 6,7 6,1 20,1 20,7 " strokeLinejoin="miter"></polyline>
                    <path fill="none" stroke="currentColor" vectorEffect="non-scaling-stroke" strokeLinecap="square" strokeMiterlimit="10" d="M23,7H3 C1.895,7,1,6.105,1,5v15c0,1.657,1.343,3,3,3h19V7z" strokeLinejoin="miter"></path>
                    <circle fill="none" stroke="currentColor" vectorEffect="non-scaling-stroke" strokeLinecap="square" strokeMiterlimit="10" cx="17" cy="15" r="2" strokeLinejoin="miter"></circle>
                </g>
            </svg>
        ),
        label: 'Cashless Payments',
        text: 'We provide 100% online payment support, so you don\'t have to worry about paying in cash.',
    },
    {
        icon: (
            <svg width={48} x="0px" y="0px" viewBox="0 0 24 24">
                <g transform="translate(0, 0)" fill="none">
                    <path fill="none" stroke="currentColor" vectorEffect="non-scaling-stroke" strokeLinecap="square" strokeMiterlimit="10" d="M17,15l-3,3l-8-8l3-3L4,2 L1,5c0,9.941,8.059,18,18,18l3-3L17,15z" strokeLinejoin="miter"></path>
                    <path data-color="color-2" fill="none" stroke="currentColor" vectorEffect="non-scaling-stroke" strokeLinecap="square" strokeMiterlimit="10" d="M14,1 c4.971,0,9,4.029,9,9" strokeLinejoin="miter"></path>
                    <path data-color="color-2" fill="none" stroke="currentColor" vectorEffect="non-scaling-stroke" strokeLinecap="square" strokeMiterlimit="10" d="M14,5 c2.761,0,5,2.239,5,5" strokeLinejoin="miter"></path>
                </g>
            </svg>
        ),
        label: '24/7 Premium support',
        text: 'Leave all your travel worries to us, as we are here to help you around the clock.',
    },
];

export interface MetaTag {
    name?: string;
    property?: string;
    content: string;
}

export const GROUP_BOOKING_META_TAGS: MetaTag[] = [
    { name: 'description', content: 'Book group flight tickets online with ixigo for all airlines and earn discounts. We provide the cheapest airfare on group flight bookings for multiple travelers.' },
    { property: 'og:type', content: 'website' },
    { property: 'og:url', content: 'https://www.ixigo.com/support/group' },
    { property: 'og:title', content: 'Best Group Flight Ticket Booking, Deals & Discounts Online | ixigo' },
    { property: 'og:description', content: 'Book group flight tickets online with ixigo for all airlines and earn discounts. We provide the cheapest airfare on group flight bookings for multiple travelers.' },
    { property: 'og:image', content: 'https://images.ixigo.com/image/upload/ixigo/6aaae6998a0dbccefca2ecd9f5a2f37b-mzybn.png' },
    { name: 'twitter:title', content: 'Best Group Flight Ticket Booking, Deals & Discounts Online | ixigo' },
    { name: 'twitter:description', content: 'Book group flight tickets online with ixigo for all airlines and earn discounts. We provide the cheapest airfare on group flight bookings for multiple travelers.' },
    { name: 'twitter:image', content: 'https://images.ixigo.com/image/upload/ixigo/6aaae6998a0dbccefca2ecd9f5a2f37b-mzybn.png' },
];

export const GROUP_BOOKING_PAGE_TITLE = 'Best Group Flight Ticket Booking, Deals & Discounts Online | ixigo';

export const GROUP_BOOKING_HEADING = 'Got flight group travel plan? We\'re here to help!';
export const GROUP_BOOKING_HEADING_ARRAY = ['Got flight', 'Group Travel', 'plan? We\'re here to help!'];

export const GROUP_BOOKING_SUBHEADING = 'Please fill in the details based on your travel preferences and our customer service representative will get in touch with you within 1 hour.';

export const GROUP_BOOKING_SUBHEADING_ARRAY = ['Discount for Group Bookings', 'All Airlines Supported'];


export const GROUP_BOOKING_WHY_IXIGO_HEADING = 'Why book with ixigo ?';
export const GROUP_BOOKING_WHY_IXIGO_CONTENT = 'Booking support for all airline carriers, at lowest possible fares.';


export const GROUP_FEATURE_CHIPS = [
    {
        icon: GroupAirport,
        label: 'Customised Booking Options',
        text: 'We customise and curate your trip as per your travel preferences. Just let us know!',
    },
    {
        icon: GroupCashless,
        label: 'Cashless Payments',
        text: 'We provide 100% online payment support, so you don\'t have to worry about paying in cash.',
    },
    {
        icon: GroupSupport,
        label: '24/7 Premium Support',
        text: 'Leave all your travel worries to us, as we are here to help you around the clock.'
    }
]

export const GROUP_BOOKING_DISCOUNT_HEADING = 'Discount for Group Bookings';

export const GROUP_BOOKING_DISCOUNT_CONTENT = [
    'If you want to have us search for the most economic fare available for group travel, with a longer period to confirm passenger names and flexibility to make modifications before issuing the tickets, you can ask us for a group fare with no commitment.',
    'The group fare with no commitment will allow you to confirm the ticket price for your group before making a commitment to purchase. This type of fare is often <strong>cheaper than individual tickets</strong>, since airline companies offer exclusive <strong>discounts for group bookings</strong>.',
    'If you have questions about group fares, please contact us by filling out this form and we will be pleased to offer our assistance.',
    'Policies regarding group fares may vary depending on the airline company.',
];

export const GROUP_BOOKING_AIRLINES_HEADING = 'All Indian and International Airlines supported';

export const GROUP_BOOKING_AIRLINES_CONTENT = 'Even if you need flight bookings for Air India, Spicejet, Indigo, or any other domestic or international airline (Lufthansa, British Airways...) we will support and handle it.';

export const GROUP_BOOKING_FOOTER_TEXT = '\u00A9 2023 Le Travenues Technology Ltd. India. All brands are trademarks of their respective owners.';

export const GROUP_BOOKING_LOGO_URL = 'https://images.ixigo.com/image/upload/Header/aac1498d8f956aa99344f08773c70fb6-evncq.webp';

